var link_viewer_wrapper_rtlignore_default = {
  "anchor": "hs27L"
};
export {
  link_viewer_wrapper_rtlignore_default as default
};
//# sourceMappingURL=link-viewer-wrapper.rtlignore-scss.js.map
